import * as React from 'react';
import { NewbuildingCompareFlightModalContainer } from 'shared/containers/NewbuildingCompareFlightModal';

import { NewbuildingCompareFlightBanner } from '../../components/NewbuildingCompareFlightBanner';

export const NewbuildingCompareFlightBannerContainer: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleButtonClick = React.useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleModalClose = React.useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <>
      <NewbuildingCompareFlightBanner onButtonClick={handleButtonClick} />

      {isModalOpen && <NewbuildingCompareFlightModalContainer onClose={handleModalClose} />}
    </>
  );
};
